import template from './confirmRegistration.html';
import controller from './confirmRegistration.controller';
import './confirmRegistration.scss';

let confirmRegistrationComponent = {
  bindings: {},
  template,
  controller,
  controllerAs: "vm"
};

export default confirmRegistrationComponent;



// WEBPACK FOOTER //
// ./client/app/components/confirmRegistration/confirmRegistration.component.js